import { PrimaryNav } from "@hagerty/global-navigation";
import { useEffect } from "react";

type HeaderProps = {
  firstName?: string;
  lastName?: string;
  customerId?: string;
  headerDataApiUrl: string;
  hagertyHomeUrl: string;
  logoutUrl: string;
  isStateFarmSsoLogin: boolean;
};
export const Header = ({
  firstName = "",
  lastName = "",
  customerId = "",
  hagertyHomeUrl,
  headerDataApiUrl: headerDataApi,
  logoutUrl,
  isStateFarmSsoLogin,
}: HeaderProps) => {
  const user = {
    given_name: firstName,
    family_name: lastName,
    sub: customerId,
  };

  // Global nav sets the hagerty logo link to the root of the current site.
  // There's no way to set it in the component so programmatically set it here
  // to the Hagerty home page.
  useEffect(() => {
    document
      .getElementsByClassName("hg-primarynav__link--hagerty")
      .item(0)
      ?.setAttribute("href", hagertyHomeUrl);
  }, []);

  return (
    <PrimaryNav
      dataApi={headerDataApi}
      isMinimal={isStateFarmSsoLogin}
      logo="2026"
      user={user}
      logoutAction={(e) => {
        e?.preventDefault();
        window.location.assign(logoutUrl);
      }}
    />
  );
};
